import { useEffect, useMemo, useState } from "react"
import { useSelector } from "react-redux"
import { buildOptionsMaps } from "src/utils/buildOptionsMaps"
import { firestore as db } from "src/Firebase"
import { suscriberUnits } from "src/services/admin/uh"
import { getUserByConjunto } from "src/views/usuarios/services/firestore"

const useUsers = () => {
  const [usuarios, setUsuarios] = useState([])
  const [unitsHab, setUnitsHab] = useState([])
  const [usersByUnit, setUsersByUnit] = useState([])
  const [contacts, setContacts] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const conjunto = useSelector(state => state.complex.complex)

  useEffect(() => {
    if (conjunto?.id) {
      const unsub = getUserByConjunto(
        {
          next: query => {
            const data = query.docs.map(doc => ({ id: doc.id, ...doc.data() }))
            setUsuarios(data)
          },
        },
        conjunto.id
      )
      return () => {
        setUsuarios([])
        unsub?.()
      }
    }
  }, [conjunto.id])

  useEffect(() => {
    if (conjunto?.id) {
      const unSub = suscriberUnits(conjunto.id, {
        next: query => {
          const data = query.docs.map(doc => ({ id: doc.id, ...doc.data() }))
          setUnitsHab(data)
        },
      })

      return () => {
        setUnitsHab([])
        unSub?.()
      }
    }
  }, [conjunto.id])

  useEffect(() => {
    if (conjunto?.id) {
      const unSub = db
        .collection(`conjuntos/${conjunto.id}/contactos`)
        .onSnapshot(query => {
          setContacts(
            query.docs.map(doc => ({
              id: doc.id,
              ...doc.data(),
            }))
          )
        })

      return () => {
        setContacts([])
        unSub?.()
      }
    }
  }, [conjunto.id])

  useEffect(() => {
    if (unitsHab.length > 0) {
      setIsLoading(true)
      const objUsers = {}
      usuarios.forEach(elem => {
        objUsers[elem.id] = { ...elem }
      })
      const listOfUsers = []
      unitsHab.forEach(unit => {
        const addedUsers = new Set()
        const unitContacts = contacts.filter(
          contact =>
            contact.isActive !== false &&
            ((unit.contacts || []).includes(contact.id) ||
              contact.PropertyId === unit.id ||
              contact.PropertyId === unit.Numero ||
              contact.Casa === unit.Numero)
        )

        if (unitContacts.length > 0) {
          unitContacts.forEach(contact => {
            const user = objUsers[contact.userId] || {}
            const data = {
              ...user,
              ...contact,
              isActive:
                user.isActive !== undefined ? user.isActive : contact.isActive,
            }
            addedUsers.add(contact.userId)
            listOfUsers.push({
              ...data,
              EsPropietario: contact.type === "owner",
              id: `${unit.id}/${contact.id}`,
              idUser: contact.userId,
              contactId: contact.id,
              idUnit: unit.id,
              Casa: unit.Numero,
              Alicuota: unit.Alicuota,
              Tipo: unit.Tipo || "",
              tipo: unit.Tipo || "",
              grupos: data.Grupos || data.grupos || [],
              Rentada: unitContacts.some(item => item.type !== "owner"),
              fullname: `${data.Nombre || ""} ${data.Apellido || ""}`.trim(),
              label: `${unit.Numero} -> ${data.Nombre || ""} ${
                data.Apellido || ""
              }`.trim(),
            })
          })
        }

        if (unit.IdPropietario && !addedUsers.has(unit.IdPropietario)) {
          const data = objUsers[unit.IdPropietario]
          if (data) {
            addedUsers.add(data.id)
            listOfUsers.push({
              ...data,
              id: `${unit.id}/${data.id}`,
              idUser: data.id,
              idUnit: unit.id,
              EsPropietario: true,
              Casa: unit.Numero,
              Alicuota: unit.Alicuota,
              Tipo: unit.Tipo || "",
              tipo: unit.Tipo || "",
              grupos: data.Grupos || data.grupos || [],
              Rentada: unit.Rentada,
              IdInquilino: unit.IdInquilino || "",
              fullname: `${data.Nombre} ${data.Apellido}`,
              label: `${unit.Numero} -> ${data?.Nombre} ${data?.Apellido}`,
            })
          }
        }
        if (unit.IdInquilino && !addedUsers.has(unit.IdInquilino)) {
          const data = objUsers[unit.IdInquilino]
          if (data) {
            addedUsers.add(data.id)
            listOfUsers.push({
              ...data,
              EsPropietario: false,
              type: "contact",
              id: `${unit.id}/${data.id}`,
              idUser: data.id,
              idUnit: unit.id,
              Casa: unit.Numero,
              Alicuota: unit.Alicuota,
              Tipo: unit.Tipo || "",
              tipo: unit.Tipo || "",
              grupos: data.Grupos || data.grupos || [],
              fullname: `${data.Nombre} ${data.Apellido}`,
              label: `${unit.Numero} -> ${data?.Nombre} ${data?.Apellido}`,
            })
          }
        }
      })
      listOfUsers.sort((a, b) => {
        const unitOrder = a.Casa?.toString().localeCompare(
          b.Casa?.toString(),
          "en",
          {
            numeric: true,
          }
        )
        if (unitOrder !== 0) {
          return unitOrder
        }

        return (
          Number(Boolean(b.EsPropietario)) - Number(Boolean(a.EsPropietario))
        )
      })
      setUsersByUnit(listOfUsers)
      setIsLoading(false)
    } else {
      setUsersByUnit([])
      setIsLoading(false)
    }
  }, [contacts, usuarios, unitsHab])

  const { optionsById } = useMemo(
    () => buildOptionsMaps(usersByUnit),
    [usersByUnit]
  )

  return { contacts, isLoading, usersByUnit, optionsById, usuarios, unitsHab }
}

export default useUsers
